import { ScrollA } from './scroll-a'
import { AnimateBox } from '../../components/animate-box'

interface SectionEProps {
  title: string
}
export const SectionG = ({ title }: SectionEProps) => {
  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          获得国家级专精特新“小巨人”企业、高新技术企业等权威认定，多项技术成果荣获省部级科技奖励
        </AnimateBox>
      </div>
      <AnimateBox>
        <ScrollA />
      </AnimateBox>
    </>
  )
}
